
import { Loader, WandSparkles } from 'lucide-react';
import React from 'react';

import { Button, ButtonProps } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { cn } from '@/lib/utils';
import { useGetBillingSession } from '@/services/billing/mutations';

export const BillingSessionForm = ({
  sparkle,
  organizationId,
  ctaText = 'Go to Billing Portal',
  ctaClassname,
  ...rest
}: {
  sparkle?: boolean;
  organizationId?: number;
  ctaText?: string;
  ctaClassname?: string;
} & ButtonProps) => {
  const { toast } = useToast();

  const { mutate, isPending } = useGetBillingSession({
    onSuccess: (url) => {
      window.location.href = url;
    },
    onError: (error) => {
      const { title, message } = error.getErrorMessage({
        title: 'Uh oh! Something went wrong.',
        message: 'There was a problem getting your billing session.',
      });
      toast({
        variant: 'destructive',
        title,
        description: Array.isArray(message) ? message.join(' ') : message,
      });
    },
  });

  if (!organizationId) {
    return null;
  }

  return (
    <Button
      type="button"
      onClick={() => mutate({ organizationId })}
      disabled={isPending}
      className={cn(
        'flex items-center font-semibold cursor-pointer gap-2',
        ctaClassname,
      )}
      {...rest}
    >
      {isPending ? (
        <>
          <Loader className="h-4 w-4 animate-spin" />
          <span>Redirecting...</span>
        </>
      ) : sparkle ? (
        <>
          <WandSparkles className="h-4 w-4" /> {ctaText}
        </>
      ) : (
        ctaText
      )}
    </Button>
  );
};
